import { IPage, IProduct } from 'src/common/types/CatalogType';
import {
  Environments,
  IEnhancedEcommerceProduct,
} from 'src/services/googleAnalytics/enhancedEcommerce/types';

export const getEnvironment = (
  brand: NodeJS.ProcessEnv['BRAND_IDENTIFIER'],
): Environments => {
  switch (brand) {
    case 'boticario':
      return Environments.boticario;
    case 'boticario_reseller':
      return Environments.boticarioReseller;
    case 'eudora':
      return Environments.eudora;
    default:
      return Environments.notSet;
  }
};

export const getPrice = (
  price: IProduct['price'],
  discountPrice: IProduct['discountPrice'],
): IEnhancedEcommerceProduct['price'] => {
  return discountPrice < price ? discountPrice : price;
};

const ONE_ITEM = 1;
const SEPARATOR = ' e ';

const hasMany = (itemsLength: number) => itemsLength > ONE_ITEM;

const correctTermForPages = (pagesLength: number) =>
  hasMany(pagesLength) ? 'Páginas' : 'Página';

export const parseListName = (pages: number[]) =>
  `${correctTermForPages(pages.length)} ${pages.join(SEPARATOR)}`;

export const addOneToPosition = (position: number) => position + 1;

export const getCurrentPagesNumber = (pages: IPage[]) =>
  pages.map((page) => page.number);
